import { HeadCell } from '~/core/components/shared/Table/TableHead/types';
import { IntegrationAccountSortableEnum } from '~/core/types/graphql.types';

export const headCells: HeadCell[] = [
  {
    id: IntegrationAccountSortableEnum.Name,
    numeric: false,
    disablePadding: true,
    label: 'Account Name',
    sx: {
      '& .MuiTableSortLabel-root': {
        justifyContent: 'flex-end !important',
      },
    },
  },
  {
    id: IntegrationAccountSortableEnum.CustomerId,
    numeric: false,
    disablePadding: true,
    label: 'Ad Account ID',
    sx: {
      '& .MuiTableSortLabel-root': {
        justifyContent: 'flex-end !important',
      },
    },
  },
  {
    id: IntegrationAccountSortableEnum.Access,
    numeric: false,
    disablePadding: true,
    label: 'MotiveMetrics Access',
    sx: {
      '& .MuiTableSortLabel-root': {
        justifyContent: 'flex-end !important',
      },
    },
  },
  {
    id: IntegrationAccountSortableEnum.UpdatedAt,
    numeric: false,
    disablePadding: true,
    label: 'Last Updated',
    sx: {
      '& .MuiTableSortLabel-root': {
        justifyContent: 'flex-end !important',
      },
    },
  },
];

export const headCellsFreeAccount: HeadCell[] = [
  {
    id: IntegrationAccountSortableEnum.Name,
    numeric: false,
    disablePadding: true,
    label: 'Account Name',
    sx: {
      '& .MuiTableSortLabel-root': {
        justifyContent: 'flex-end !important',
      },
    },
  },
  {
    id: IntegrationAccountSortableEnum.CustomerId,
    numeric: false,
    disablePadding: true,
    label: 'Ad Account ID',
    sx: {
      '& .MuiTableSortLabel-root': {
        justifyContent: 'flex-end !important',
      },
    },
  },
  {
    id: IntegrationAccountSortableEnum.UpdatedAt,
    numeric: false,
    disablePadding: true,
    label: 'Last Updated',
    sx: {
      '& .MuiTableSortLabel-root': {
        justifyContent: 'flex-end !important',
      },
    },
  },
];
